export default __webpack_public_path__ + "static/media/check.4246dd1a.svg";